/**
 * Utilities for consultation room routes.
 * Consultation room URL: /consultations/:id (for audio, video, and chat).
 * Legacy paths /chats/:id and /text-chat/:id are preserved as backward-compatible aliases.
 */

/**
 * Checks if the given path is an active consultation/call room.
 * Matches /consultations/:id, /chats/:id, /text-chat/:id, and /appointments/:id/session.
 *
 * @param {string} path Pathname to test
 * @returns {boolean}
 */
export const isLiveCallPath = (path) => {
  const p = path || (typeof window !== "undefined" ? window.location?.pathname : "") || "";
  if (typeof p !== "string" || !p) return false;
  return (
    /^\/consultations(\/|$)/.test(p) ||
    /^\/chats(\/|$)/.test(p) ||
    /^\/text-chat(\/|$)/.test(p) ||
    /^\/textchat(\/|$)/.test(p) ||
    /^\/appointments\/[^/]+\/session(\/|$)/.test(p)
  );
};

/**
 * Normalizes and checks if a consultation mode is chat.
 *
 * @param {string|object} mode
 * @returns {boolean}
 */
export const isChatMode = (mode) => {
  const m = String(mode?.slug || mode?.title?.en || mode || "").toLowerCase().trim();
  return m === "chat" || m === "text" || m === "text-chat" || m === "textchat";
};

/**
 * Resolves the URL path for entering a consultation room.
 * For audio, video, and chat, the URL is always /consultations/:id.
 *
 * @param {string|number} appointmentId Appointment ID
 * @param {string|object} [mode] Consultation mode (kept for backwards-compatible call signatures)
 * @returns {string} URL path
 */
export const resolveConsultationPath = (appointmentId, mode = "video") => {
  if (!appointmentId) return "/";
  return `/consultations/${appointmentId}`;
};

export default isLiveCallPath;
